<template>
  <target-form-styles>
    <div class="create-target-form__name-section">
      <v-row justify="space-around">
        <v-col md="5">
          <target-name
            :isNewTarget="true"
            :targetType="target.target"
            :initialValue="targetNameInitialValue"
            :disabled="false"
            @updateName="val => (target.display_name = val)"
            @updateNameIsValid="isValid => (nameIsValid = isValid)"
          />
        </v-col>
      </v-row>
    </div>

    <div class="create-las__options-area">
      <v-row justify="space-around">
        <v-col md="4">
          <advertiser-select
            class="vue-select"
            ref="advertiserSelect"
            :label="hasResearchIntent ? 'Advertiser (Optional)' : 'Advertiser'"
            :initialValue="target.advertiser"
            @update="val => (target.advertiser = val)"
            :disabled="hasMarketingIntent"
          ></advertiser-select>
        </v-col>
        <v-col
          v-if="hasMarketingIntent"
          md="4"
        >
          <streaming-select
            v-model="target.viewing_stream"
            :viewingOption="5"
          />
        </v-col>
        <v-col
          v-if="hasMarketingIntent"
          md="4"
        >
          <marketing-network-select
            class="vue-select"
            ref="marketingNetworkSelect"
            placeholder="Select"
            :initialValue="initialNetwork"
            @update="val => selectedNetwork(val)"
          ></marketing-network-select>
        </v-col>
      </v-row>
    </div>

    <div class="evenly-distributed justify-space-around">
      <action-button
        :label="buttonLabel"
        id="adBuildAudienceBtn"
        color="secondary"
        @click.native="handleSubmit"
        :disabled="!buttonClickable"
      >
      </action-button>
    </div>
  </target-form-styles>
</template>

<script>
  import TargetName from '../components/TargetName'
  import { CREATE_TARGET } from '@/appLogic/targets/createTarget/store/actions'
  import ActionButton from '@/components/common/actionButton'
  import TargetFormStyles from './TargetFormStyles'
  import AdvertiserSelect from '@/appComponents/targets/components/AdvertiserSelect'
  import StreamingSelect from '@/appComponents/targets/components/StreamingSelect'
  import MarketingNetworkSelect from '@/appComponents/targets/components/MarketingNetworkSelect'
  import {
    INTENTS,
    TARGET_ACTIONS,
    ACTIVATION_STATUS,
    DESTINATIONS,
    VIEWING_STREAMS,
  } from '@/appLogic/targets/Constants'
  import { cloneDeep } from 'lodash'

  export default {
    components: {
      ActionButton,
      TargetFormStyles,
      AdvertiserSelect,
      StreamingSelect,
      MarketingNetworkSelect,
      TargetName,
    },
    props: {
      targetName: {
        type: String,
        default: '',
      },
      onComplete: {
        type: Function,
        default: () => console.log('You lose...'),
      },
    },
    data() {
      return {
        target: {
          destinations: [DESTINATIONS.SYMPHONY],
          display_name: this.targetName,
          advertiser: null,
          target: 'audience_discovery',
          target_datasource: 'amrld',
          target_definition: {
            promotedNetworks: [],
          },
          intents: [],
        },
        nameIsValid: false,
        initialNetwork: null,
      }
    },
    created() {
      this.target.advertiser =
        this.$store.state.createTarget.intents &&
        this.$store.state.createTarget.intents.includes(INTENTS['Marketing']['Name'])
          ? { Advertiser_id: '11532', Name: 'TURNER PROMOTIONS' }
          : null
    },
    computed: {
      buttonClickable() {
        return (
          this.nameIsValid &&
          (this.hasResearchIntent ||
            (this.hasMarketingIntent && this.target.target_definition.promotedNetworks.length > 0))
        )
      },
      buttonClass() {
        return this.buttonClickable ? 'target-form__button--active' : 'target-form__button--inactive'
      },
      buttonLabel() {
        return this.isDuplicate ? 'Duplicate' : this.hasMarketingIntent ? 'Build Audience' : 'Get Started'
      },
      userPermissions() {
        return this.$store.state.auth.permissions
      },
      advertiserDropDownClass() {
        return this.hasResearchIntent
          ? 'create-target-form__advertiser-dropdown'
          : 'evenly-distributed__target-form-dropdown-select'
      },
      hasMarketingIntent() {
        return this.isDuplicate
          ? this.target.intents && this.target.intents.includes(INTENTS['Marketing']['Name'])
          : this.$store.state.createTarget.intents &&
              this.$store.state.createTarget.intents.includes(INTENTS['Marketing']['Name'])
      },
      hasResearchIntent() {
        return this.isDuplicate
          ? this.target.intents && this.target.intents.includes(INTENTS['Research']['Name'])
          : this.$store.state.createTarget.intents &&
              this.$store.state.createTarget.intents.includes(INTENTS['Research']['Name'])
      },
      hasSalesIntent() {
        return this.isDuplicate
          ? this.target.intents && this.target.intents.includes(INTENTS['Sales']['Name'])
          : this.$store.state.createTarget.intents &&
              this.$store.state.createTarget.intents.includes(INTENTS['Sales']['Name'])
      },
      targetNameInitialValue() {
        if (this.isDuplicate) {
          return this.originalTarget.display_name + ' COPY'
        } else {
          return ''
        }
      },
      isDuplicate() {
        return this.initialTargetAction === TARGET_ACTIONS.DUPLICATE
      },
      initialTargetAction() {
        return this.$store.state.createTarget.initialTargetAction
      },
      originalTarget() {
        return {
          ...(this.$store.state.createTarget.initialTarget || this.$store.state.createTarget || {}),
          display_name: this.targetName || (this.$store.state.createTarget.initialTarget || {}).display_name || '',
        }
      },
    },
    watch: {
      originalTarget() {
        if (this.originalTarget) {
          let cp = cloneDeep(this.originalTarget)
          if (this.isDuplicate) {
            cp.id = undefined
            cp.cae_id = undefined
            cp.activated = false
            cp.auto_post = false
            cp.activation_status = ACTIVATION_STATUS.DRAFT
            cp.audience_size = cp.audience_size ? cp.audience_size : 0
            cp.intents = cp.metadata.intents
              ? cp.metadata.intents.map(intent => {
                  return intent['Name']
                })
              : []
            cp.last_posting = null
            delete cp.created
            delete cp.last_update

            this.target = cp
            if (this.target.target_definition.promotedNetworks) {
              let network = this.target.target_definition.promotedNetworks[0]
              this.initialNetwork = { Name: network, value: network }
            }
          }
        }
      },
    },
    methods: {
      handleSubmit() {
        this.target.username = this.$store.state.auth.username
        this.target.metadata = {
          intents:
            this.target.intents && this.target.intents.length > 0
              ? this.target.intents.map(i => INTENTS[i])
              : this.$store.state.createTarget.intents.map(i => INTENTS[i]),
        }
        if (typeof this.target.viewing_stream === 'undefined') {
          this.target.viewing_stream = VIEWING_STREAMS.LSD
        }
        this.target.advertiser = this.target.advertiser ? this.target.advertiser : { Name: null }
        this.$store.dispatch(CREATE_TARGET, this.target)
        // this.onComplete() // comment it out because it will close stepper model while loading workbench page
      },
      selectedNetwork(val) {
        if (val) {
          this.target.target_definition.promotedNetworks = [val]
        } else {
          this.target.target_definition.promotedNetworks = []
        }
      },
    },
  }
</script>

<style lang="scss">
  .create-las {
    height: 100%;
    width: 100%;

    &__options-area {
      display: flex;
      margin: 40px 0;
      justify-content: space-around;
    }
  }
</style>



// WEBPACK FOOTER //
// CreateAd.vue?0cbd6aaa